import { StatusFormatter } from '@components'

import { Button, Icon, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useLocale } from '../../../../../../../../../../hooks/useLocale'
import { accountSyncStatusToVariant } from '../../../../consts/accountSyncStatusToVariant'
import { SyncStatus } from '../../../../enums/syncStatus'
import * as Styled from './styles'

interface BankAccountSyncStatusProps {
  syncStatus: SyncStatus
  syncDate?: string
  isRenewing?: boolean
  onRenew?: () => void
}

export const AccountSyncStatus = ({
  syncStatus,
  syncDate,
  isRenewing,
  onRenew,
}: BankAccountSyncStatusProps): ReactElement => {
  const { t } = useTranslation()
  const { code } = useLocale()

  const { variant, label } =
    accountSyncStatusToVariant[syncStatus] || accountSyncStatusToVariant[SyncStatus.OfflineData]
  const text = typeof label === 'function' ? label(syncDate, code) : label
  const shouldShowSyncDate = syncStatus === SyncStatus.Synced && syncDate
  const shouldShowRenewButton = syncStatus === SyncStatus.NeedsRenewal

  const icon = shouldShowSyncDate ? <Icon icon="refresh" color="currentColor" /> : <StatusFormatter variant={variant} />

  if (shouldShowRenewButton) {
    return (
      <Styled.RenewButtonWrapper>
        <Button variant="outlined" size="sm" onClick={onRenew} icon="plug" loading={isRenewing}>
          {t(text)}
        </Button>
      </Styled.RenewButtonWrapper>
    )
  }

  return (
    <Styled.AccountSyncStatusWrapper>
      {icon}
      <Text variant="bodySM" weight="medium">
        {t(text)}
      </Text>
    </Styled.AccountSyncStatusWrapper>
  )
}
